import { render } from "./Klaar.vue?vue&type=template&id=c6ce739a"
import script from "./Klaar.vue?vue&type=script&lang=js"
export * from "./Klaar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__